import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal, FiLock } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import AccountEditModal from 'components/Accounts/AccountEditModal';
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as rulesActions from 'actions/rulesActions';
import { accountsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from 'react-i18next';

class AccountsList extends Component {
	constructor(props) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditAccountModal = this.openEditAccountModal.bind(this);
		this.openDeleteAccountModal = this.openDeleteAccountModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal()
	}

	openEditAccountModal(account) {
		this.props.showModal({
			open: true,
			title: this.props.t('accounts.editAccount'),
			style: { width: '400px' },
			content: <AccountEditModal account={account} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openDeleteAccountModal(idAccount) {
		this.props.showModal({
			open: true,
			title: this.props.t('accounts.deleteAccount'),
			style: { width: '350px' },
			message: this.props.t('accounts.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idAccount),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(message) {
		this.props.showModal({
			open: true,
			title: this.props.t('accounts.deleteError'),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idAccount) => {
		const response = await accountsService.remove(idAccount);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		}
		else {
			this.props.getAccounts();
			this.closeModal();
		}
	}

	getAccountActions = (account) =>
		account.system ? (
			<FiLock className="icon-locked" title={this.props.t('accounts.systemAccount')} />
		) : (
			<Dropdown>
				<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item as="button" onClick={() => this.openEditAccountModal(account)}>{this.props.t('common.edit')}</Dropdown.Item>
					<Dropdown.Item as="button" onClick={() => this.openDeleteAccountModal(account.id)}>{this.props.t('common.delete')}</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		);

	getAccountDisplayName = (account) =>
		this.props.t(`accounts.names.${account.name}`, {
			defaultValue: account.name,
		});

	getColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			sortAccessor: (account) => this.getAccountDisplayName(account),
			render: (account) => {
				const name = this.getAccountDisplayName(account);

				return account.system ? (
					name
				) : (
					<button
						type="button"
						className="btn-transparent"
						onClick={() => this.openEditAccountModal(account)}
					>
						{name}
					</button>
				);
			},
		},
		{
			key: "type",
			header: this.props.t('accounts.typeHeader'),
			render: (account) => account.type,
		},
	];

	accountMatchesSearch = (account, query) => {
		const displayName = String(this.getAccountDisplayName(account)).toLowerCase();
		const rawName = String(account.name || "").toLowerCase();
		const type = String(account.type || "").toLowerCase();

		return (
			displayName.includes(query) ||
			rawName.includes(query) ||
			type.includes(query)
		);
	};

	render() {
		const query = String(this.props.searchAccount || "").trim().toLowerCase();
		const accounts = (this.props.accounts || []).filter((account) =>
			query ? this.accountMatchesSearch(account, query) : true
		);

		return (
			<DataTable
				tableClassName="table-accounts table-hover"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getColumns()}
				rows={accounts}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t('common.noResults')}
				actionsColumn={{
					render: (account) => this.getAccountActions(account),
					className: "td-actions",
				}}
			/>
		);
	}
}


const mapStateToProps = (reducers) => {
	return reducers.rulesReducer;
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getAccounts: (q) => dispatch(rulesActions.getAccounts(q)),
})


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AccountsList))
